import { render } from "./AddCoordinatorsModal.vue?vue&type=template&id=a5831942"
import script from "./AddCoordinatorsModal.vue?vue&type=script&lang=js"
export * from "./AddCoordinatorsModal.vue?vue&type=script&lang=js"

import "./AddCoordinatorsModal.vue?vue&type=style&index=0&id=a5831942&lang=css"

import exportComponent from "/var/www/html/vitare-carenew/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__